module.exports = __webpack_public_path__ + "img/img02.b5d00264.png";